export function init() {
  window.jQuery(function ($) {
    $(document).ready(function () {

      const hash = window.location.hash;
      console.log('init', hash);

      /*
        $.extend($.validator.messages, {
          min: 'Введите значение больше {0}',
          max: 'Введите значение меньше {0}',
          required: 'Поле обязательно',
          email: 'Неверный email',
        });
        */

      //scroll
      $(window).scroll(window.onScroll);

      // resize
      $(window).resize(function () {
        window.prepareMenuLinks();
      });

      $(window).resize();
      $(window).scroll();

      // scroll to
      if (hash) {
        window.slideTo(hash);
      }
    });
  });
}
